import * as React from "react"
import { SvgComponentProps } from "../types/SVGPropType"
const TelegramSVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={23}
    fill="none"
    {...props}
  >
    <rect
      width={21.802}
      height={21.802}
      x={0.884}
      y={0.843}
      fill="#fff"
      rx={10.901}
    />
    <path
      fill="#0C1518"
      d="M7.445 11.176a445.695 445.695 0 0 1 5.404-2.282c2.573-1.05 3.108-1.232 3.456-1.238a.619.619 0 0 1 .36.106.38.38 0 0 1 .131.246c.013.07.028.232.016.358-.14 1.436-.743 4.922-1.05 6.53-.13.681-.386.91-.633.932-.538.049-.947-.349-1.468-.683-.816-.525-1.276-.85-2.068-1.362-.915-.591-.322-.916.2-1.447.136-.139 2.507-2.253 2.553-2.445.005-.024.01-.113-.043-.16-.055-.048-.135-.032-.192-.019-.082.018-1.385.863-3.909 2.533-.37.249-.704.37-1.004.364-.331-.007-.968-.184-1.44-.334-.58-.185-1.042-.283-1.002-.597.021-.164.25-.331.69-.502Z"
    />
  </svg>
)
export default TelegramSVG
